const processResponse = (response, commit, callingFunction) => {
  if (response.status !== 200) {
    // setTimeout(() => {
    //   commit(
    //     'app/showToast',
    //     {
    //       color: 'error',
    //       message: callingFunction + ': ' + response.statusText,
    //       timeout: 5000
    //     },
    //     { root: true }
    //   );

    //   return false;
    // });
    return false;
  } else if (
    (Array.isArray(response.data) && response.data.length <= 0) ||
    (response.data !== null &&
      typeof response.data === 'object' &&
      Object.keys(response.data).length <= 0)
  ) {
    // setTimeout(() => {
    //   commit(
    //     'app/showToast',
    //     {
    //       color: 'error',
    //       message: 'No data found in ' + callingFunction,
    //       timeout: 5000
    //     },
    //     { root: true }
    //   );
    // });

    return false;
  } else {
    return true;
  }
};

export default {
  processResponse
};
